export const resolveTo = (url) => {
    if (!url || url === "#") return null;
    return `/${url.replace(/^\//, "")}`;
};

export const matchesPath = (url, pathname) => {
    const to = resolveTo(url);
    if (!to) return false;
    if (to === "/") return pathname === "/" || pathname === "";
    return pathname === to || pathname.startsWith(`${to}/`);
};

export const flattenMenu = (nodes, trail = []) => {
    const items = [];

    for (const node of Array.isArray(nodes) ? nodes : []) {
        if (Array.isArray(node.items) && node.items.length) {
            const nextTrail = node.name ? [...trail, node.name] : trail;
            items.push(...flattenMenu(node.items, nextTrail));
            continue;
        }

        const to = resolveTo(node.url);
        if (!to || !node.name || node.horizontalRule) continue;

        items.push({id: node.id, name: node.name, to, target: node.target, breadcrumb: trail.join(" › ")});
    }

    return items;
};

export const findMenuItem = (nodes, pathname) => {
    let best = null;

    const walk = (list) => {
        for (const node of list) {
            if (Array.isArray(node.items) && node.items.length) {
                walk(node.items);
                continue;
            }
            const urls = [node.url, ...(node.activeUrls ?? [])];

            for (const url of urls) {
                if (!matchesPath(url, pathname)) continue;

                const to = resolveTo(url);
                if (!best || to.length > best.to.length) best = {node, to};
            }
        }
    };

    walk(Array.isArray(nodes) ? nodes : []);
    return best?.node ?? null;
};
